/**
 * Narrow Idgit Ink accessibility enhancements.
 * Structural IDs, labels and heading levels belong in Liquid. This file avoids
 * whole-document rescans and never rewrites IDs owned by Shopify or applications.
 */
function normalizePolicyHeadings(root = document) {
  root.querySelectorAll?.('.shopify-policy__body h1').forEach((heading) => {
    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    while (heading.firstChild) replacement.append(heading.firstChild);
    heading.replaceWith(replacement);
  });
}

function repairKnownThemeHeadings(root = document) {
  root.querySelectorAll?.('h4.facets--filters-title').forEach((heading) => {
    const replacement = document.createElement('h3');
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    while (heading.firstChild) replacement.append(heading.firstChild);
    heading.replaceWith(replacement);
  });
}

function repairReviewSvgIds(root = document) {
  const wrappers = [];
  if (root.matches?.('.rating-wrapper')) wrappers.push(root);
  root.querySelectorAll?.('.rating-wrapper').forEach((wrapper) => wrappers.push(wrapper));

  wrappers.forEach((wrapper, index) => {
    if (wrapper.dataset.idgitSvgIdsRepaired === 'true') return;
    const half = wrapper.querySelector('linearGradient#half');
    const star = wrapper.querySelector('symbol#star');
    if (!half || !star) return;

    const classToken = [...wrapper.classList].find((name) => name.startsWith('rating-wrapper-'));
    const suffix = (classToken || `rating-${index + 1}`).replace(/[^a-zA-Z0-9_-]/g, '-');
    const halfId = `half-${suffix}`;
    const starId = `star-${suffix}`;
    half.id = halfId;
    star.id = starId;

    wrapper.querySelectorAll('use').forEach((use) => {
      const href = use.getAttribute('href') || use.getAttribute('xlink:href');
      if (href === '#star') {
        use.setAttribute('href', `#${starId}`);
        use.setAttribute('xlink:href', `#${starId}`);
      }
      if (use.getAttribute('fill') === 'url(#half)') use.setAttribute('fill', `url(#${halfId})`);
    });
    wrapper.dataset.idgitSvgIdsRepaired = 'true';
  });
}

function enhance(root = document) {
  normalizePolicyHeadings(root);
  repairKnownThemeHeadings(root);
  repairReviewSvgIds(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
} else {
  enhance();
}

document.addEventListener('shopify:section:load', (event) => enhance(event.target));
